import { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import {
  getAllPackages,
  getAsignaciones,
  getSelectZonasActivas,
} from '../../../../service/inventario/asignacion';
import {
  getPackageListById,
  getSelectRazon,
} from '../../../../service/inventario/devolucion';
import { SimpleAlert } from '../../../../../_mexablock/helpers';
import { getDevolucion } from '../../../../service/inventario/devolucion';

export const useGetAll = (reloadGrid: number, filters: any) => {
  const [data, setData] = useState<any[]>([]);
  const [loadingRequest, setLoadingRequest] = useState<number>(0);
  const history = useHistory();

  useEffect(() => {
    const fetchPost = async () => {
      try {
        const res = await getDevolucion(filters);
        if (res) {
          setData(res);
          setLoadingRequest(Math.random() * 40);
        }
      } catch (error) {
        history.push('/error/500');
      } finally {
        setLoadingRequest(0);
      }
    };

    if (reloadGrid) {
      fetchPost();
    }
  }, [reloadGrid, filters]);

  return { data, loadingRequest };
};

export const useSelectZonasActivas = (show: boolean) => {
  const [data, setData] = useState<any[]>([]);

  useEffect(() => {
    const fetchPost = async () => {
      try {
        const res = await getSelectZonasActivas();
        setData(res || []);
      } catch (error: any) {
        const message =
          error?.response?.data?.message || 'Error al cargar zonas';
        SimpleAlert(message, 3000, 'error');
        setData([]);
      }
    };

    if (show) {
      fetchPost();
    } else {
      setData([]);
    }
  }, [show]);

  return { data };
};

export const useSelectRazon = (show: boolean) => {
  const [data, setData] = useState<any[]>([]);
  useEffect(() => {
    const fetchPost = async () => {
      const res = await getSelectRazon()
        .then()
        .catch((error) => {
          let resMessageToast: string = '';
          const {
            data: { message },
          } = error.response;
          resMessageToast = `${message}`;
          SimpleAlert(resMessageToast, 3000, 'error');
        });
      if (res) {
        setData(res);
      }
    };
    if (show) {
      fetchPost();
    }
  }, [show]);
  return { data };
};

export const useSelectPackage = (show: boolean) => {
  const [data, setData] = useState<any[]>([]);
  useEffect(() => {
    const fetchPost = async () => {
      const res = await getAllPackages()
        .then()
        .catch((error) => {
          let resMessageToast: string = '';
          const {
            data: { message },
          } = error.response;
          resMessageToast = `${message}`;
          SimpleAlert(resMessageToast, 3000, 'error');
        });
      if (res) {
        setData(res);
      }
    };
    if (show) {
      fetchPost();
    }
  }, [show]);
  return { data };
};

export const useList = (id: number) => {
  const [data, setData] = useState<any[]>([]);
  useEffect(() => {
    const fetchPost = async () => {
      const res = await getPackageListById(id)
        .then()
        .catch((error) => {
          let resMessageToast: string = '';
          const {
            data: { message },
          } = error.response;
          resMessageToast = `${message}`;
          SimpleAlert(resMessageToast, 3000, 'error');
        });
      if (res) {
        setData(res);
      }
    };
    if (id > 0) {
      fetchPost();
    } else {
      setData([]);
    }
  }, [id]);
  return { data };
};
